/* IMPORT */
import cleanup from './cleanup.js';
import CacheKeyed from './for.cache.keyed.js';
import CacheUnkeyed from './for.cache.unkeyed.js';
import get from './get.js';
import isObservable from './is_observable.js';
import isStore from './is_store.js';
import memo from './memo.js';
import resolve from './resolve.js';
import untrack from './untrack.js';
import { frozen } from '../objects/callable.js';
import { SYMBOL_CACHED, SYMBOL_STORE_VALUES } from '../symbols.js';
import { isArray, isEqual } from '../utils.js';
import { callStack } from './debugger.js';
function _for(values, fn, fallback = [], options) {
    const stack = callStack();
    if (isArray(values) && !isStore(values)) { // Fast path for plain arrays
        const isUnkeyed = !!options?.unkeyed;
        return frozen(untrack(() => {
            if (values.length) {
                return values.map((value, index) => {
                    return resolve(fn(isUnkeyed && !isObservable(value) ? frozen(value) : value, index));
                });
            }
            else {
                return resolve(fallback);
            }
        }));
    }
    else { // Regular path
        const { dispose, map } = options?.unkeyed ? new CacheUnkeyed(fn, !!options.pooled) : new CacheKeyed(fn); //TSC
        cleanup(dispose);
        const value = memo(() => {
            return get(values) ?? [];
        }, {
            equals: (next, prev) => {
                return !!next && !!prev && !next.length && !prev.length && !isStore(next) && !isStore(prev);
            },
            stack
        });
        return memo(() => {
            const array = value();
            if (isStore(array)) {
                array[SYMBOL_STORE_VALUES];
            }
            return untrack(() => {
                const results = map(array);
                return results?.length ? results : resolve(fallback);
            });
        }, {
            equals: (next, prev) => {
                return isArray(next) && !!next[SYMBOL_CACHED] && isArray(prev) && isEqual(next, prev);
            },
            stack
        });
    }
}
/* EXPORT */
export default _for;
